<template>
  <div>
    <b-row>
      <b-col cols="12" md="6">
        <b-card class="h-100 mb-0">
          <Tasks />
        </b-card>
      </b-col>
      <b-col cols="12" md="6">
        <b-card class="h-100 mb-0">
          <Notes />
        </b-card>
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col cols="12">
        <b-card>
          <betting-history />
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12">
        <b-card>
          <AccountTransaction />
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12">
        <b-card> <DepositMatches /> </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12">
        <b-card> <BonusCreditHistory /> </b-card>
      </b-col>
    </b-row>

    <b-modal
      ref="bettingInfo"
      title="Bet Information"
      centered
      cancel-disabled
      footer-class="border-0"
      size="md"
    >
      <b-container fluid>
        <b-row>
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center"
            style="gap: 8px"
          >
            <p class="text-body font-weight-bolder">Bet ID:</p>
            <p class="text-body">48124082</p>
          </b-col>
          <b-col
            cols="12"
            md="4"
            class="d-flex align-items-center"
            style="gap: 8px"
          >
            <p class="text-body font-weight-bolder">UserName:</p>
            <p class="text-body">jsmith123</p>
          </b-col>
        </b-row>
        <b-row class="mt-1">
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center"
            style="gap: 8px"
          >
            <p class="text-body font-weight-bolder text-nowrap">Bet Date:</p>
            <p class="text-body text-nowrap">21/05/2025 13:32:32</p>
          </b-col>
          <b-col
            cols="12"
            md="4"
            class="d-flex align-items-center"
            style="gap: 8px"
          >
            <p class="text-body font-weight-bolder text-nowrap">Bet Type:</p>
            <p class="text-body text-nowrap">Win (Fixed Odds)</p>
          </b-col>
        </b-row>
        <b-row class="mt-1">
          <b-col class="d-flex align-items-center" style="gap: 8px">
            <p class="text-body font-weight-bolder">Status:</p>
            <div
              class="rounded-pill position-relative bg-warning"
              style="width: fit-content; padding: 2px 10px"
            >
              <span class="text-nowrap font-weight-bolder">Resulted Win</span>
            </div>
          </b-col>
        </b-row>
        <b-row class="mt-1">
          <b-col
            cols="12"
            md="4"
            class="d-flex align-items-center"
            style="gap: 8px"
          >
            <p class="text-body">Stake:</p>
            <p class="text-body font-weight-bolder">$100.00</p>
          </b-col>
          <b-col
            cols="12"
            md="4"
            class="d-flex align-items-center"
            style="gap: 8px"
          >
            <p class="text-body">Odds:</p>
            <p class="text-body font-weight-bolder">$2.00</p>
          </b-col>
          <b-col
            cols="12"
            md="4"
            class="d-flex align-items-center"
            style="gap: 8px"
          >
            <p class="text-body">Liability:</p>
            <p class="text-body font-weight-bolder">$200.00</p>
          </b-col>
        </b-row>
        <b-row class="mt-1">
          <b-card
            class="w-100 mb-0"
            style="background: #f3f2f7; border: 1px solid #e5e7eb"
          >
            <b-row>
              <b-col>
                <p class="text-body font-weight-bolder">Selections:</p></b-col
              >
            </b-row>
            <b-row class="mt-1">
              <b-col>
                <div class="d-flex align-items-center" style="gap: 8px">
                  <p class="text-body font-weight-bolder">Thoroughbred</p>
                  <p class="text-body">- Melton Race 7</p>
                </div>
                <div class="d-flex align-items-center" style="gap: 8px">
                  <p class="text-body font-weight-bolder">Selection:</p>
                  <p class="text-body">Black Caviar 2.00</p>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100">
          <b-col cols="6">
            <b-button variant="outline-secondary" class="w-100"
              >Amend Bet</b-button
            >
          </b-col>
          <b-col cols="6"
            ><b-button variant="danger" class="w-100"
              >Cancel Bet</b-button
            ></b-col
          >
        </b-row>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { objectProp } from "@/helpers/props";
import { formatCurrencyBuiltInFunc } from "@/helpers/utils";
import Spinner from "@core/components/Spinner";
import {
  BCard,
  BButton,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BMedia,
  BRow,
  BFormCheckbox,
  BInputGroupAppend,
  BContainer,
  BCardText,
  BFormSelect,
  BFormTextarea,
  BBadge,
  BInputGroup,
  BTable,
  BCardBody,
  BLink,
  BPagination,
  BModal,
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import VueGoogleAutocomplete from "vue-google-autocomplete";
import vSelect from "vue-select";
import { format, differenceInYears } from "date-fns";
import AccountTransaction from "./AccountTransaction.vue";
import BettingHistory from "./components/BettingHistory.vue";
import Tasks from "./components/Tasks.vue";
import Notes from "./components/Notes.vue";
import DepositMatches from "./components/DepositMatches.vue";
import BonusCreditHistory from "./components/BonusCreditHistory.vue";

export default {
  components: {
    BCard,
    BButton,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    Spinner,
    ValidationProvider,
    BContainer,
    BFormCheckbox,
    BCardText,
    BFormSelect,
    flatPickr,
    ValidationObserver,
    BForm,
    VueGoogleAutocomplete,
    BFormTextarea,
    BBadge,
    BInputGroup,
    BInputGroupAppend,
    vSelect,
    BTable,
    BCardBody,
    BInputGroup,
    BFormGroup,
    BMedia,
    BLink,
    BPagination,
    BModal,
    AccountTransaction,
    BettingHistory,
    Tasks,
    Notes,
    DepositMatches,
    BonusCreditHistory,
  },
  props: {
    userData: objectProp(),
  },
  data() {
    return {};
  },

  computed: {},
  async mounted() {},

  methods: {
    format,
    handleOpenDepositMatchModal() {
      this.$bvModal.show("apply-deposit-match-modal");
    },
  },
  setup() {
    return {
      formatCurrencyBuiltInFunc,
    };
  },
};
</script>

<style lang="scss" scoped>
/* === SMALL TEXT STYLE — match CustomerInfo.vue === */

/* Section headings (h4, h5) */
::v-deep h4,
::v-deep h5 {
  font-size: 13px !important;
  font-weight: 700;
  color: #1a1f36;
}

/* Table headers */
::v-deep .table th {
  font-size: 10px;
  font-weight: 600;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  padding: 8px 10px;
}

/* Table cells */
::v-deep .table td {
  font-size: 11px;
  padding: 8px 10px;
  color: #1a1f36;
  vertical-align: middle;
}

/* Card body padding */
::v-deep .card-body {
  padding: 12px;
}

/* Badges */
::v-deep .badge {
  font-size: 10px;
  padding: 3px 8px;
}

/* Form controls (inputs, selects, flatpickr) */
::v-deep .form-control,
::v-deep .custom-select,
::v-deep .vs__dropdown-toggle {
  font-size: 11px;
  height: 30px;
}

::v-deep .vs__search {
  font-size: 11px;
}

/* Buttons inside cards */
::v-deep .card .btn {
  font-size: 11px;
  padding: 4px 10px;
}

/* Pagination */
::v-deep .pagination {
  font-size: 11px;
}

::v-deep .page-link {
  padding: 4px 8px;
  font-size: 11px;
}

/* General text */
::v-deep .text-body,
::v-deep .text-muted,
::v-deep .text-dark,
::v-deep p {
  font-size: 11px;
}

::v-deep .small,
::v-deep small {
  font-size: 10px;
}

/* flatpickr input */
::v-deep .flatpickr-input {
  font-size: 11px;
  height: 30px;
}

/* Form labels */
::v-deep label,
::v-deep .form-group label {
  font-size: 11px;
  font-weight: 500;
}

/* Bet Information Modal */
::v-deep .modal-title {
  font-size: 13px;
  font-weight: 700;
}

::v-deep .modal-body p {
  font-size: 11px;
}

::v-deep .modal-body .rounded-pill span {
  font-size: 10px;
}

::v-deep .modal-footer .btn {
  font-size: 11px;
}
</style>
